import React from 'react';
import { SectionHeading } from './SectionHeading';
import { OfferCard } from './OfferCard';
import { CtaButton } from './CtaButton';
import { modules } from '../data/offer';
export function Included() {
  return <section className="w-full bg-ink-900 py-20" aria-labelledby="incluye" data-id="element-85" data-mp="4fn1n9kctm84">
      <div className="mx-auto max-w-5xl px-5" data-id="element-86" data-mp="3vl4us1eo5rfq">
        <SectionHeading eyebrow="Todo lo que recibes" title={<span id="incluye" data-id="element-88" data-mp="x27s87t09uam">6 sistemas completos, no 6 videos sueltos</span>} subtitle="Cada pieza cubre una parte del proceso: la oferta, el activo, el tráfico, el cierre y la entrega." data-id="element-87" data-mp="3vmfyk1846z6u" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-89" data-mp="n41odknn2e34">
          {modules.map((item, index) => <OfferCard key={item.id} item={item} index={index} data-id="element-90" data-mp="i56xrwjfjl8g" data-mpi={index} />)}
        </div>

        <div className="mx-auto mt-12 max-w-xl" data-id="element-91" data-mp="37wdadw7bmddi">
          <CtaButton subLabel="Acceso inmediato a los 6 sistemas + 3 bonos" data-id="element-92" data-mp="37sxx8yx7jeeq" />
        </div>
      </div>
    </section>;
}